import { useAtom, useAtomValue } from 'jotai/index';
import { useEffect } from 'react';

import { CaregiverCallConfirmationType } from '@/shared/call/CaregiverCallConfirmationType';

import {
    caregiverCallConfirmationQueryAtom,
    confirmationAtom,
} from '../model/store';
import { useSyncCaregiverCallConfirmationData } from '../model/useSyncCaregiverCallConfirmationData';

type UseCaregiverCallConfirmationBaseProps = {
    confirmationType: CaregiverCallConfirmationType;
    consultationUid: string;
    onClose: () => void;
};

export const useCaregiverCallConfirmationBase = ({
    confirmationType,
    consultationUid,
    onClose,
}: UseCaregiverCallConfirmationBaseProps) => {
    useSyncCaregiverCallConfirmationData({
        confirmationType,
        consultationUid,
        onClose,
    });

    const {
        data: confirmationData,
        isPending: isLoading,
        error,
    } = useAtomValue(caregiverCallConfirmationQueryAtom);

    const [confirmation, setConfirmation] = useAtom(confirmationAtom);

    useEffect(() => {
        if (confirmationData) {
            setConfirmation(confirmationData);
        }
    }, [confirmationData, setConfirmation]);

    return {
        confirmation,
        confirmationData,
        isLoading,
        error,
    };
};
